<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <template v-if="advanced">
              <a-col :md="4" :sm="24">
                <a-form-item label="剧名" prop="nickname">
                  <a-input v-model="queryParam.videoName" placeholder="请输入剧名" allow-clear />
                </a-form-item>
              </a-col>
              <!-- <a-col :md="4" :sm="24">
                <a-form-item label="用户ID" prop="userId">
                  <a-input v-model="queryParam.userId" placeholder="用户ID" allow-clear />
                </a-form-item>
              </a-col> -->
              <a-col :md="4" :sm="24">
                <a-date-picker prop="startTime" v-model="queryParam.startTime"
                  style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%" format="YYYY-MM-DD"
                  allow-clear placeholder="开始时间" />
              </a-col>
              <a-col :md="4" :sm="24">
                <a-date-picker prop="endTime" v-model="queryParam.endTime"
                  style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%" format="YYYY-MM-DD"
                  allow-clear placeholder="结束时间" />
              </a-col>
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </template>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type='primary' @click='handleExport'>导出</a-button>
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />

        <a-button type='primary' @click='handleExport2'>导出原始数据</a-button>
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :sexOptions="dict.type.sys_user_sex" :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable" @ok="getList" />
      <!-- 数据展示 -->

      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list" :pagination="false"
        :bordered="tableBordered">
        <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl"
          v-image-preview :src="record.coverUrl">

      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" :rowKey="(record, index) => index + 1" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delUser, changeIsOpen, getVideoTotalData } from '@/api/biz/userForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      userData: {},
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      sort: '',
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        userId: null,
      },
      columns: [
        // {
        //   title: '三方账号',
        //   dataIndex: 'mobile',
        //   align: 'center'
        // },
        // {
        //   title: '邮箱',
        //   dataIndex: 'email',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '序号',
          // ellipsis: true,,
          customRender: (text, record, index) => index + 1,
          align: 'center'
        },
        {
          title: '剧名',
          dataIndex: 'videoName',
          align: 'center'
        },

        {
          title: '封面',
          dataIndex: 'coverUrl',
          align: 'center',
          scopedSlots: { customRender: 'coverUrl' }
        },
        {
          title: '集数',
          dataIndex: 'totalNum',
          align: 'center'
        },
        {
          title: '播放次数(切换排序规则)',
          dataIndex: 'realLookNum',
          align: 'center',
          customHeaderCell: () => {
            return {
              style: { cursor: 'pointer' },
              on: {
                click: () => {
                  this.queryParam.sort = this.queryParam.sort === 'real_look_num' ? '' : 'real_look_num';
                  this.getList();
                }
              }
            };
          }
        },
        {
          title: 'PV',
          dataIndex: 'pv',
          align: 'center'
        },
        {
          title: 'UV',
          dataIndex: 'uv',
          align: 'center'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created() {
    this.getList()
    this.getUserTotalData()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      const params = {
        ...this.queryParam,
        startTime: this.queryParam.startTime ? this.queryParam.startTime.format("YYYY-MM-DD") + " 00:00:00" : null,
        endTime: this.queryParam.endTime ? this.queryParam.endTime.format("YYYY-MM-DD") + " 23:59:59" : null,
      }
      console.log('请求参数:', params);
      getVideoTotalData(params).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // getUserTotalData() {
    //   getUserTotalData().then(response => {
    //     this.userData = response.data
    //   })
    // },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        videoName: undefined,
        email: undefined,
        nickname: undefined,
        isVip: undefined,
        invitationCode: undefined,
        showId: undefined,
        type: undefined,
        userId: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },



    changeIsOpen(e, record) {
      record.status = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          '操作成功'
        )
        return record.status = e ? 1 : 0
      })
    },



    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ "id": id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          const params = {
            ...that.queryParam,
            pageNum: 1,
            pageSize: 1000,
            startTime: that.queryParam.startTime ? that.queryParam.startTime.format("YYYY-MM-DD") + " 00:00:00" : null,
            endTime: that.queryParam.endTime ? that.queryParam.endTime.format("YYYY-MM-DD") + " 23:59:59" : null,
          }
          that.download('video/videos/export', params, `短剧报表_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    },
    /** 导出按钮操作 */
    handleExport2() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          const params = {
            ...that.queryParam,
            pageNum: 1,
            pageSize: 1000,
            startTime: that.queryParam.startTime ? that.queryParam.startTime.format("YYYY-MM-DD") + " 00:00:00" : null,
            endTime: that.queryParam.endTime ? that.queryParam.endTime.format("YYYY-MM-DD") + " 23:59:59" : null,
          }
          that.download('video/videos/export2', params, `短剧报表_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
